<div class="score-ring" [class.score-ring--sm]="size === 'sm'" [class.score-ring--lg]="size === 'lg'">
  <svg viewBox="0 0 100 100" class="score-ring__svg" [ngClass]="colorClass">
    <circle class="score-ring__track" cx="50" cy="50" r="45"></circle>
    <circle
      class="score-ring__progress"
      cx="50"
      cy="50"
      r="45"
      [style.strokeDasharray]="circumference"
      [style.strokeDashoffset]="dashOffset"
    ></circle>
  </svg>
  <div class="score-ring__center">
    <span class="score-ring__value">{{ clampedScore }}</span>
    <span *ngIf="label" class="score-ring__label">{{ label }}</span>
  </div>
</div>
